export enum ThemeCodes {
  BlackFriday = 'black_friday',
  Natal = 'natal',
  AnoNovo = 'ano_novo',
  Black = 'black',
  BlackFriday2022 = 'black_friday2022',
  Pascoa = 'pascoa',
  DiaMaes = 'dia_maes',
  DiaPais = 'dia_pais',
  DiaNamorados = 'dia_namorados',
  Arraia = 'arraia',
  Copa2022 = 'copa_2022',
  ChinaInBox = 'chinainbox',
  Quiosque = 'quiosque',
  Carnaval = 'carnaval',
  TemaPersonalizado = 'tema-personalizado',
  CacauShow = 'cacau_show',
  MeuCardapioClassico = 'meucardapioclassico'
}

export interface Tema {
  id?: string;
  nome: string;
  tipo: 'personalizado' | 'comemorativo';
  codigo?: string;
  imagem?: string;
  novo?: boolean;
  atualizado?: boolean;
}

export const TEMAS_DO_SISTEMA: Tema[] = [
  { nome: 'Clássico', codigo: ThemeCodes.MeuCardapioClassico, tipo: 'comemorativo', imagem: 'tema_meucardapioclassico.png' },
  { nome: 'Carnaval 2025', codigo: ThemeCodes.Carnaval, tipo: 'comemorativo', novo: true, imagem: 'tema-carnaval-2025.png' },
  { nome: 'Copa 2022', codigo: ThemeCodes.Copa2022, tipo: 'comemorativo', imagem: 'tema_copa_2022.png' },
  { nome: 'Black Friday', codigo: ThemeCodes.BlackFriday, tipo: 'comemorativo', imagem: 'tema_black_friday.png' },
  { nome: 'Black Friday 2022', codigo: ThemeCodes.BlackFriday2022, tipo: 'comemorativo', imagem: 'tema_black_friday2022.png' },
  { nome: 'Dia das Mães', codigo: ThemeCodes.DiaMaes, tipo: 'comemorativo', imagem: 'tema_dia_maes.png' },
  { nome: 'Dia dos Pais', codigo: ThemeCodes.DiaPais, tipo: 'comemorativo', imagem: 'tema_dia_dos_pais.png' },
  { nome: 'Black', codigo: ThemeCodes.Black, tipo: 'comemorativo', imagem: 'tema_black.png' },
  { nome: 'Páscoa', codigo: ThemeCodes.Pascoa, tipo: 'comemorativo', imagem: 'tema_pascoa.png' },
  { nome: 'Natal', codigo: ThemeCodes.Natal, tipo: 'comemorativo', imagem: 'tema_natal.png' },
  { nome: 'Ano Novo', codigo: ThemeCodes.AnoNovo, tipo: 'comemorativo', atualizado: true, imagem: 'tema_ano_novo.png' },
  { nome: 'Arraiá', codigo: ThemeCodes.Arraia, tipo: 'comemorativo', imagem: 'tema_arraia.png' },
  { nome: 'Dia dos Namorados', codigo: ThemeCodes.DiaNamorados, tipo: 'comemorativo', imagem: 'tema_dia_namorados.png' }
];